import classNames from 'classnames';
import React from 'react';

import {useFormatShortcut} from 'notebook/tables/toolbar/useFormatShortcut';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export interface FormatToggleButtonProps {
  tooltip: string;
  icon: BenchlingIconName;
  format: string;
  active: boolean;
  disabled: boolean;
  onClick: (format: string, activate: boolean) => void;
}

export function FormatToggleButton({
  format,
  active,
  disabled,
  onClick,
  tooltip,
  icon,
}: FormatToggleButtonProps): JSX.Element {
  const shortcut = useFormatShortcut(
    format,
    () => {
      onClick(format, !active);
    },
    {disabled}
  );

  return (
    <Tooltip text={`${tooltip} (${shortcut})`} disableContentSelection={true}>
      <Button
        className={classNames({
          'is-active': active,
          'is-disabled': disabled,
        })}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        icon={icon}
        iconAltText={tooltip}
        disabled={disabled}
        onClick={() => {
          onClick(format, !active);
        }}
        size={ButtonSize.MINI}
      />
    </Tooltip>
  );
}
